import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/fetchWerkbakken'
import type { FetchWerkbakken } from '../types/FetchWerkbakken'

export { useWerkbakkenStore }

const useWerkbakkenStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<FetchWerkbakken['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
